/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetInboxFilterResponseData,
  GetInboxFilterResponseDataFromJSON,
  GetInboxFilterResponseDataFromJSONTyped,
  GetInboxFilterResponseDataToJSON
} from './GetInboxFilterResponseData'

/**
 *
 * @export
 * @interface GetInboxFilterResponse
 */
export interface GetInboxFilterResponse {
  /**
   *
   * @type {number}
   * @memberof GetInboxFilterResponse
   */
  status?: number
  /**
   *
   * @type {GetInboxFilterResponseData}
   * @memberof GetInboxFilterResponse
   */
  data?: GetInboxFilterResponseData
}

export function GetInboxFilterResponseFromJSON(json: any): GetInboxFilterResponse {
  return GetInboxFilterResponseFromJSONTyped(json, false)
}

export function GetInboxFilterResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetInboxFilterResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetInboxFilterResponseDataFromJSON(json['data'])
  }
}

export function GetInboxFilterResponseToJSON(value?: GetInboxFilterResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetInboxFilterResponseDataToJSON(value.data)
  }
}
